<template>
    <div>Video Player</div>
</template>